import React, { FunctionComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { backofficeUrl } from '../../../shared/helpers';

const Bootstrap: FunctionComponent<{}> = (props) => {
    return <Navigate to={backofficeUrl('/dashboard')} />;
};

export default Bootstrap;
